import { Component } from "@angular/core";
import { ActivatedRoute, ParamMap, Router } from "@angular/router";
import { Observable } from "rxjs";
import { MutexService } from "common/concurrency/mutex.service";
import { ModuleService } from "management/modules/module.service";

@Component({
	templateUrl: "./start-progress.component.html",
})
export class StartProgressComponent {
	paramMap$: Observable<ParamMap>;

	constructor(
		private route: ActivatedRoute,
		private router: Router,
		private mutexService: MutexService,
		private moduleService: ModuleService,
	) {
		this.paramMap$ = route.paramMap;
	}

	close(): void {
		this.router.navigate([
			"workspace",
			this.route.snapshot.paramMap.get("workspaceId"),
			this.route.snapshot.paramMap.get("processVersion"),
			"home",
		]);
	}

	summary(): void {
		this.router.navigate(
			[
				"..",
				"summary",
				{ jobName: this.route.snapshot.paramMap.get("jobName"), jobType: this.route.snapshot.paramMap.get("jobType") },
			],
			{
				relativeTo: this.route,
			},
		);
	}

	stop(): void {
		this.mutexService.invoke(`stop${this.route.snapshot.paramMap.get("jobName")!}`, async () => {
			await this.moduleService.stop(this.route.snapshot.paramMap.get("workspaceId")!, [
				this.route.snapshot.paramMap.get("jobName")!,
			]);
			this.close();
		});
	}

	getMessageKeyPrefix(paramMap: ParamMap): string {
		if (paramMap.get("jobType") === "COPY_PROCESS") {
			return "install.copy";
		}

		if (paramMap.get("jobType") === "IMPORT_PROCESS") {
			return "install.import";
		}

		return "process.modules.add";
	}
}
